export default __webpack_public_path__ + "static/media/panneau-mot-de-passe.4987cde4.svg";